import LoaderSkeleton from '@components/LoaderSkeleton';
import CustomCheckbox from '@components/shared/CustomCheckbox';
import PropTypes from 'prop-types';

import { SIGNATURES_PAGE_LIMIT } from '@shared/constants';
import signatureId from '@shared/helpers/signatureId';

import styles from './DocsMobile.module.scss';
import { isSelected } from '../DocTableRow/helpers';
import DocTableRow from '../DocTableRow/DocTableRow';

const DocsMobile = ({
  data,
  onSelect,
  selected,
  areAllSelected,
  handleSelectAllClick,
}) => {
  return data ? (
    <>
      <div className={styles.checkbox}>
        <CustomCheckbox
          checked={areAllSelected}
          onChange={handleSelectAllClick}
          small
          label='Docs'
        />
      </div>
      {data.signatures.map(item => (
        <DocTableRow
          key={signatureId(item)}
          isMobile
          item={item}
          currentPage={data?.currentPage}
          onSelect={onSelect}
          isSelected={isSelected(selected, signatureId(item))}
        />
      ))}
    </>
  ) : (
    Array.from({ length: SIGNATURES_PAGE_LIMIT }, (_, index) => (
      <div key={index} className={styles.skeleton}>
        <div>
          <LoaderSkeleton width={'100%'} height={36} />
        </div>
        <div className={styles.skeletonFlex}>
          <LoaderSkeleton width={'80%'} height={64} />
          <LoaderSkeleton width={'80%'} height={64} />
        </div>
      </div>
    ))
  );
};

DocsMobile.propTypes = {
  data: PropTypes.shape({
    signatures: PropTypes.arrayOf(
      PropTypes.shape({
        user_id: PropTypes.string,
        date: PropTypes.string,
        form_name: PropTypes.string,
        signature_type: PropTypes.string,
        signed_doc_url: PropTypes.string,
      }),
    ),
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  onSelect: PropTypes.func,
  selected: PropTypes.object,
  areAllSelected: PropTypes.bool,
  handleSelectAllClick: PropTypes.func,
};

export default DocsMobile;
